import ConfirmDialog from './module/ConfirmDialog.tsx';
import {ReactQueryDevtools} from 'react-query/devtools';
import {RouterProvider} from 'react-router-dom';
import {getDynamicRoutes} from './routes/DynamicRoutes.tsx';
import {Analytics} from '@vercel/analytics/react';

function App() {
  const router = getDynamicRoutes();

  return (
    <ConfirmDialog>
      <Analytics />
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </ConfirmDialog>
  );
}

export default App;
